'use client'
import { Typography, styled, SxProps } from '@mui/material'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

interface SubHeading {
  heading: string
  content: string[]
}

interface MainContent {
  mainHeading: string
  subHeadings: SubHeading[]
}

interface HeadingWithNumberedSubHeadingsProps {
  content: MainContent[]
  centerHeader?: boolean
  styleOverRides?: SxProps
}

const HeadingNumberedBlock = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(7),
  li: {
    '&::marker': {
      color: theme.palette.primary.dark
    }
  }
}))

const HeadingWithNumberedSubHeadings: React.FC<HeadingWithNumberedSubHeadingsProps> = ({
  content,
  centerHeader,
  styleOverRides
}) => {
  return (
    <HeadingNumberedBlock>
      {content.map((content) => (
        <div key={uuidv4()}>
          <Typography
            className={[centerHeader ? 'text-center' : ''].join(' ')}
            variant="h2"
            sx={{ ...styleOverRides }}
          >
            {content.mainHeading}
          </Typography>
          {content.subHeadings.map((subHeading, subIndex) => (
            <div key={uuidv4()}>
              <ol start={subIndex + 1} data-testid="numbered-list">
                <li>{subHeading.heading}</li>
              </ol>
              <div>
                {subHeading.content.map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex}>{paragraph}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </HeadingNumberedBlock>
  )
}

export default HeadingWithNumberedSubHeadings
